import { SecondaryLoadingAnimation } from '@outbound-ai/ursa'
import { IClaim } from 'features/claims/types'
import { Tooltip } from '@outbound-ai/ursa'
import styled, { useTheme } from 'styled-components'
import { PositionEnum } from 'types/cssTypes'

interface IProps {
  callType?: 'talkToPayorRep' | 'getClaimStatus'
  claim: IClaim
  title?: string
}

export const CallTypeLabel = ({ callType = 'talkToPayorRep', claim, title }: IProps) => {
  const theme = useTheme()

  const displayTextPerCallType = {
    talkToPayorRep: {
      tooltipText:
        'During a payer agent call, Outbound’s AI agent will navigate the IVR menus and wait on hold on your behalf.  You can takeover the call at any time, removing the AI agent from the conversation. You can also minimize the call view, up until the payer agent joins the call.',
      title: title || `Call to ${claim?.insurerName ? claim.insurerName : 'Unknown'} rep in progress`,
    },
    getClaimStatus: {
      tooltipText:
        'During a payer agent call, Outbound’s AI agent will navigate the IVR menus and wait on hold on your behalf.  You can takeover the call at any time, removing the AI agent from the conversation. You can also minimize the call view, up until the payer agent joins the call.',
      title: 'Get Claim Status from VA',
    },
  }

  const { tooltipText, title: displayTitle } = displayTextPerCallType[callType]
  return (
    <Div>
      <div>
        <SecondaryLoadingAnimation bgColor={theme.colors.info.darker} /> {displayTitle}
      </div>
      <Tooltip
        className="text-with-tooltip"
        tooltipText={tooltipText}
        position={PositionEnum.bottom}
        positionContent={0}
        positionTooltipArrow={100}
        tooltipStyles={{
          'max-width': '25rem',
          width: '25rem',
          textAlign: 'left',
          transform: 'translateY(84%) translateX(-80%)',
        }}
      >
        <span>Learn More</span>
      </Tooltip>
    </Div>
  )
}

const Div = styled.div`
  position: relative;
  text-align: center;
  padding: 0.5rem 1.5rem;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  background: ${({ theme }) => theme.colors.tertiary.lighter};
  border: 2px solid ${({ theme }) => theme.colors.tertiary.darker};
  border-radius: ${({ theme }) => theme.borderRadius.rounded};

  > div {
    display: flex;
    gap: 0.5rem;
    justify-content: center;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grey.darker};
  }

  .text-with-tooltip {
    position: absolute;
    right: 1.5rem;
    top: 50%;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.colors.info.darker};
    font-size: 0.85rem;
    border-bottom: 1px dashed ${({ theme }) => theme.colors.info.darker};
    z-index: 1;
    .tooltip-arrow {
      left: 24rem;
    }
  }
`
